<template>
    <div :class="componentName === 'FilmCompanyView' ? 'film_company_component_view' : ''" v-if="!isLoading">

        <!--        <p class="back_link">-->
        <!--            <a href="/bussines_companies">-->
        <!--                <svg width="14.000000" height="11.000000" viewBox="0 0 14 11" fill="none"-->
        <!--                     xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">-->
        <!--                    <path id="Vector 1 (Border)"-->
        <!--                          d="M2.65796 6.32568L5.72949 9.58704C6.03735 9.91406 6.03735 10.4279 5.72949 10.7548C5.42139 11.0818 4.93774 11.0818 4.62964 10.7548L0.230957 6.08386C-0.0769043 5.75696 -0.0769043 5.24304 0.230957 4.91614L4.62964 0.245239C4.93774 -0.0817871 5.42139 -0.0817871 5.72949 0.245239C6.03735 0.572144 6.03735 1.08594 5.72949 1.41296L2.65796 4.67432L13.2224 4.67432C13.658 4.67432 14 5.0376 14 5.5C14 5.9624 13.658 6.32568 13.2224 6.32568L2.65796 6.32568Z"-->
        <!--                          fill="#F7C100" fill-opacity="1.000000" fill-rule="evenodd"/>-->
        <!--                </svg>-->
        <!--                <span>Бизнес-площадки</span></a>-->
        <!--        </p>-->

        <div class="columns" style="margin-bottom: 0;">
            <div class="column" style="padding-bottom: 0;">
                <div class="header_title">
                    {{ user.firmName }}
                </div>
            </div>
            <div class="column is-narrow">
            </div>
        </div>
        <p class="company_type_text">{{ user.speciality }} компания</p>

        <div class="content__wrapper">
            <div v-if="user.logo" class="logo_block">
<!--                <img :src="'https://script.moviestart.ru/uploads/images/user/' + user.logo" id="image">-->
								<ImageRender
												id="image"
											:src="get_uploaded_image_asset('user/'+user.logo)"
								></ImageRender>
            </div>

            <div class="countries_block">
                <div class="columns">
                    <div class="column is-narrow">
                        <div class="columns">
                            <div class="column is-narrow" style="align-items: center; display: flex">
                                <svg width="27.999939" height="35.000000" viewBox="0 0 27.9999 35" fill="none"
                                     xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <path id="Vector"
                                          d="M13.9999 0C6.26801 0 0 6.26813 0 14C0 21.7319 13.9999 35 13.9999 35C13.9999 35 27.9999 21.7319 27.9999 14C27.9999 6.26813 21.7319 0 13.9999 0ZM13.9999 3.81824C15.337 3.81824 16.6611 4.08148 17.8964 4.5932C19.1317 5.10486 20.2541 5.8548 21.1996 6.80029C22.145 7.74579 22.895 8.86823 23.4067 10.1036C23.9184 11.3389 24.1818 12.663 24.1818 14C24.1818 15.3371 23.9184 16.6611 23.4067 17.8964C22.895 19.1317 22.145 20.2542 21.1996 21.1996C20.2541 22.1451 19.1317 22.895 17.8964 23.4067C16.6611 23.9184 15.337 24.1818 13.9999 24.1818C12.6628 24.1818 11.3389 23.9184 10.1036 23.4067C8.86823 22.895 7.74579 22.1451 6.80035 21.1996C5.85486 20.2542 5.10492 19.1317 4.5932 17.8964C4.08154 16.6611 3.81818 15.3371 3.81818 14C3.81818 12.663 4.08154 11.3389 4.5932 10.1036C5.10492 8.86823 5.85486 7.74579 6.80035 6.80029C7.74579 5.8548 8.86823 5.10486 10.1036 4.5932C11.3389 4.08148 12.6628 3.81824 13.9999 3.81824Z"
                                          fill="#EC983F" fill-opacity="1.000000" fill-rule="nonzero"/>
                                    <path id="Vector"
                                          d="M17.7057 7.58569C17.6488 7.58453 17.5919 7.59113 17.5367 7.6051L9.51752 9.61108C9.43262 9.62744 9.35193 9.66095 9.2804 9.70959C9.20886 9.75818 9.14795 9.82086 9.10144 9.8938C9.05493 9.96674 9.0238 10.0485 9.00989 10.1339C8.99603 10.2192 8.99969 10.3064 9.02063 10.3903C9.04163 10.4742 9.07947 10.553 9.1319 10.6218C9.18433 10.6906 9.25024 10.748 9.32562 10.7905C9.40094 10.8329 9.48419 10.8596 9.57019 10.8688C9.65613 10.8781 9.74316 10.8696 9.82581 10.8441L17.8449 8.83801C17.9958 8.80194 18.1282 8.71198 18.2174 8.58508C18.3066 8.45819 18.3464 8.3031 18.3293 8.14899C18.3122 7.99481 18.2394 7.85217 18.1246 7.74792C18.0098 7.64368 17.8608 7.58789 17.7057 7.58569Z"
                                          fill="#EC983F" fill-opacity="1.000000" fill-rule="nonzero"/>
                                    <path id="Vector"
                                          d="M9.22955 12.0908L9.22955 13.6817L18.775 13.6817L18.775 12.0908L9.22955 12.0908Z"
                                          fill="#EC983F" fill-opacity="1.000000" fill-rule="nonzero"/>
                                    <path id="Vector"
                                          d="M9.22955 14.9547L9.22955 18.3553C9.22955 18.7623 9.55548 19.0911 9.95538 19.0911L18.0516 19.0911C18.4515 19.0911 18.775 18.7621 18.775 18.3553L18.775 14.9547L9.22955 14.9547Z"
                                          fill="#EC983F" fill-opacity="1.000000" fill-rule="nonzero"/>
                                </svg>

                            </div>
                            <div class="column">
                                <p class="countries_block__title">Страна</p>
                                <p class="countries_block__sub">{{ user.country }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="column is-narrow">
                        <p class="countries_block__title">Регион</p>
                        <p class="countries_block__sub">{{ user.region }}</p>
                    </div>
                    <div class="column is-narrow">
                        <p class="countries_block__title">Город</p>
                        <p class="countries_block__sub">{{ user.city }}</p>
                    </div>
                </div>
            </div>

						<br v-if="is_org && user.userData && (user.userData.phone || user.userData.email)">
            <div v-if="is_org && user.userData && (user.userData.phone || user.userData.email)" class="countries_block">
                <div class="columns">
                    <div class="column is-narrow" v-if="user.userData && user.userData.phone">
                        <p class="countries_block__title">Телефон</p>
                        <p class="countries_block__sub">{{ user.userData.phone }}</p>
                    </div>
                    <div class="column is-narrow" v-if="user.userData && user.userData.email">
                        <p class="countries_block__title">Email</p>
                        <p class="countries_block__sub">{{ user.userData.email }}</p>
                    </div>
                </div>
            </div>

            <div class="bos_block">
                <p class="header_title2">Руководитель</p>
                <div class="columns bos_columns">
                    <div class="column is-narrow">
                        <div class="avatar_block" v-if="user.avatar">
<!--                            <img :src="'https://script.moviestart.ru/uploads/images/' + user.avatar" id="image">-->
                            <ImageRender
                                    id="image"
                                    :src="get_uploaded_image_asset(user.avatar)"
                            ></ImageRender>

                        </div>
<!--												<div class="avatar_block" v-else>-->
<!--													<img src="https://script.moviestart.ru/images/anonym.png" id="image">-->
<!--												</div>-->
                    </div>
                    <div class="column">
                        <p class="bos_fio">{{ user.lastName }} {{ user.firstName }} {{ user.patronymic }}</p>
                        <div>{{ user.about }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
								<template v-if="films.length > 0">
                    <div style="margin-top: 30px;" class="header_title2">Фильмы компании</div>

                    <div class="film_type_selector">
                        <div class="film_type_selector_item" @click="film_selector_tab = 1" :class="film_selector_tab === 1 ? 'is_active' : ''">
                            <span>Все проекты</span>
                        </div>
                        <div class="film_type_selector_item" @click="film_selector_tab = 2" :class="film_selector_tab === 2 ? 'is_active' : ''">
                            <span>Реализованные</span>
                        </div>
                        <div class="film_type_selector_item" @click="film_selector_tab = 3" :class="film_selector_tab === 3 ? 'is_active' : ''">
                            <span>В производстве</span>
                        </div>
                    </div>
								</template>


                <FilmsRenderComponent
                        :films="film_filtered"
                        :is-show-actions-block="isShowActionsBlock"
                        @update="getFilms"
                ></FilmsRenderComponent>

								<template v-if="practices.length > 0">
                    <div class="header_title2">Другие практики</div>

                    <div class="film_type_selector">
                        <div class="film_type_selector_item" @click="practic_selector_tab = 1" :class="practic_selector_tab === 1 ? 'is_active' : ''">
                            <span>Все проекты</span>
                        </div>
                        <div class="film_type_selector_item" @click="practic_selector_tab = 2" :class="practic_selector_tab === 2 ? 'is_active' : ''">
                            <span>Реализованные</span>
                        </div>
                        <div class="film_type_selector_item" @click="practic_selector_tab = 3" :class="practic_selector_tab === 3 ? 'is_active' : ''">
                            <span>В производстве</span>
                        </div>
                    </div>

                    <PracticsRenderComponent
                            :practices="practic_filtered"
                            :is-show-actions-block="isShowActionsBlock"
                    ></PracticsRenderComponent>
								</template>
            </div>
        </div>
    </div>
    <div v-else>
        <Spin></Spin>
    </div>
</template>

<script>
export default {
  name: "FilmCompanyView",
  data() {
    return {
      componentName: this.$options.name
    };
  }
};
</script>

<script setup>
import {ref, computed} from "vue";
import {Spin} from "ant-design-vue"
import axios from "axios";
import Json from '@/services/json'
import 'cropperjs/dist/cropper.css';
import FilmsRenderComponent from "@/components/Base/FilmsRenderComponent.vue";
import PracticsRenderComponent from "@/components/Base/PracticsRenderComponent.vue";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

let user = ref({
  id: '',
  avatar: '',
  logo: '',
  firmName: '',
  email: '',
  country: '',
  region: '',
  city: '',
  about: '',
  phone: '',
  firstName: '',
  lastName: '',
  patronymic: '',
  speciality: ''
});
let isDataUpdating = ref(false);
let imgSrc = ref('');
let imgSrcLogo = ref('');
let isLoading = ref(false);
let film_selector_tab = ref(1);
let practic_selector_tab = ref(1);

const isShowActionsBlock = computed(() => {
  return false;
  //15198 - это аккаунт Moviestart-distribution@yandex.ru
  //return window.currentUserId === '15198';
})

async function getData() {
  isLoading.value = true;
  const response = await axios.get('/get_film_company/' + window.userid);
  user.value = Json.replaceKeys(response.data);
  isLoading.value = false;
}

getData();


let films = ref([]);

async function getFilms() {
  const response = await axios.post('/project/getUserFilms', null, {
    params: {
      userId: window.userid
    }
  })
  films.value = response.data;
}

getFilms();

let practices = ref([]);

async function getPractices() {
  const response = await axios.post('/project/getUserPractices', null, {
    params: {
      userId: window.userid
    }
  })
  practices.value = response.data;
}

getPractices();


const film_filtered = computed(() => {
  if (film_selector_tab.value === 1) {
    return films.value;
	}
  if (film_selector_tab.value === 2) {
    return films.value.filter((item)=>{
      return item.project_data?.status === 'Реализован';
		});
  }
  if (film_selector_tab.value === 3) {
    return films.value.filter((item)=>{
      return item.project_data?.status === 'В производстве';
    });
  }
  return [];
})

const practic_filtered = computed(() => {
  if (practic_selector_tab.value === 1) {
    return practices.value;
  }
  if (practic_selector_tab.value === 2) {
    return practices.value.filter((item)=>{
      return item.project_data?.status === 'Реализована';
    });
  }
  if (practic_selector_tab.value === 3) {
    return practices.value.filter((item)=>{
      return item.project_data?.status === 'В производстве';
    });
  }
  return [];
})

const is_org = computed(() => {
  return window.is_org;
})

function get_uploaded_image_asset(path) {
  return ImageService.getUserImagePath(path);
}

</script>

<style scoped>
.countries_block {
    background: rgb(247, 247, 247);
    border-radius: 12px;
    display: inline-block;
    padding: 20px;
    padding-bottom: 0;
    margin-bottom: 30px;
}

.countries_block > .columns > .column {
    margin-right: 30px;
}

.countries_block .countries_block__title {
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: 5px;
}

.countries_block .countries_block__sub {
    font-weight: 500;
    margin-bottom: 0;
}

.avatar_block:deep img {
    width: 150px;
    border-radius: 150px;
}

.bos_fio {
    color: rgb(0, 0, 0);
    font-weight: 700;
    font-size: 22px;
}

.content__wrapper {
    position: relative;
}

.logo_block:deep img {
    width: 280px;
    border-radius: 20px;
}

.logo_block {
    position: absolute;
    right: 0;
}

.company_type_text {
    background: linear-gradient(92deg, #F7C100 0.01%, #F69400 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 18px;
    font-weight: 600;
}

.film_company_component_view .back_link {
    padding-left: 0;
}

.film_type_selector {
    display: flex;
    margin-top: 20px;
    font-size: 15px;
    color: #1D232D;
}

.film_type_selector .film_type_selector_item:not(:last-child) {
    margin-right: 10px;
}
.film_type_selector_item {
		cursor: pointer;
}

.film_type_selector_item.is_active {
    font-weight: 500;
    box-shadow: inset 0 0 32px 0 rgba(255, 255, 255, 0.16);
}
.film_type_selector_item.is_active span {
    border-bottom: 3px solid;
		display: inline-block;
    padding-bottom: 7px;
    border-image: linear-gradient(135deg, #f7c100 0.01%, #f69400 100%);
    border-image-slice: 1;
}
.bos_columns {
		max-width: 750px;
}
@media (max-width: 1370px) {
    .bos_columns {
        max-width: 650px;
		}
    .logo_block img {
				width: 240px;
		}
}
@media (max-width: 1250px) {
    .logo_block {
        position: static;
        margin-bottom: 30px;
    }
    .bos_columns {
        max-width: none;
    }
}

@media (max-width: 1000px) {


		.film_type_selector {
        flex-direction: column;
		}
		.film_type_selector_item {
        margin-bottom: 10px;
				flex-grow: 0;
		}
    .countries_block {
				width: 100%;
		}
}
</style>